import React from 'react';
import { connect } from 'react-redux'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    // Button,
    Table,
    // InputGroup, Form, FormControl
} from 'react-bootstrap';
import Select from "react-select"

// import numberWithCommas from '../Classes/NumberwithComma'
import dateFormater from '../Classes/FormatDate'
import SearchBar from '../Components/SearchBar'
import { GetFilterList } from '../store/actions/masterActions'

import { getAllInspectorswithTypes, getInspectorAllocationsByInspectorId, getInspectorAllocations, GetInspectorAllocationsByInspectorIdWithRange, getInspectionDetailsByInspectorID, postAssignInspector, getInspectionDetailsByCallID } from '../store/actions/inspectionActions'

class ResourcePlanner extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            inspector: [],
            opacity: "",
            selectedFromTypeDropdown: 1,
            inspectorID: '',
            inspectorName: '',
            year: new Date().getFullYear(),
            month: new Date().getMonth() + 1,
            calenderui: false,
            modal: false,
            allocatedModal: false,
            allocatedDetail: null,
            allocatedInspectionDate: '',
            inspectionStartDate: '',
            inspectionEndDate: '',
            inspectionInstruction: '',
            allocatedinspectionIndex: 0,
            callList: false,
            selectedCalls: [],
            checkedAll: false,
            isShowFilter: false,
            finalvendorlist: [],
            finalinspectorlist: [],
            sortByInspector: [],
            array: [
                { value: 1, label: "element1" },
                { value: 2, label: "element2" },
                { value: 3, label: "element3" },
                { value: 4, label: "element4" }],
            searchTerm: new URLSearchParams(this.props.location.search).get("searchTerm") ? new URLSearchParams(this.props.location.search).get("searchTerm") : "",
            sortByWBS: new URLSearchParams(this.props.location.search).get("sortByWBS") ? (new URLSearchParams(this.props.location.search).get("sortByWBS")).split(',') : [],
            sortByPlantCode: new URLSearchParams(this.props.location.search).get("sortByPlantCode") ? (new URLSearchParams(this.props.location.search).get("sortByPlantCode")).split(',') : [],
            sortByEmployees: new URLSearchParams(this.props.location.search).get("sortByEmployees") ? (new URLSearchParams(this.props.location.search).get("sortByEmployees")).split(',') : [],
            sortByPo: new URLSearchParams(this.props.location.search).get("sortByPo") ? (new URLSearchParams(this.props.location.search).get("sortByPo")).split(',') : [],
            poDocStartDate: new URLSearchParams(this.props.location.search).get("poDocStartDate") ? new URLSearchParams(this.props.location.search).get("poDocStartDate") : "",
            poDocEndDate: new URLSearchParams(this.props.location.search).get("poDocEndDate") ? new URLSearchParams(this.props.location.search).get("poDocEndDate") : "",
            sortByVendor: new URLSearchParams(this.props.location.search).get("sortByPo") ? (new URLSearchParams(this.props.location.search).get("sortByVendor")).split(',') : [],
            searchForItem: [],
            searchForOptions: [
                {
                    label: 'Currency', value: 'Currency'
                },
                {
                    label: 'Location', value: 'Location'
                },
                {
                    label: 'Material', value: 'Material'
                },
                {
                    label: 'Payment term', value: 'Payment term'
                },
                {
                    label: 'Planner', value: 'Planner'
                },
                {
                    label: 'Plant Code', value: 'Plant Code'
                },
                {
                    label: 'PO Number', value: 'PO Number'
                },
                {
                    label: 'Purchase Group', value: 'Purchase Group'
                },
                {
                    label: 'Vendor', value: 'Vendor'
                },
                {
                    label: 'WBS', value: 'WBS'
                },
            ],
            searchFor: new URLSearchParams(this.props.location.search).get("searchFor") ? new URLSearchParams(this.props.location.search).get("searchFor") : "",
        }
    }

    componentDidMount = async () => {
        await this.props.getAllInspectorswithTypes()
        await this.getFilterList()
        await this.getInspectorallocation(this.state.year, this.state.month)
        console.log(this.props)
    }

    getFilterList = async () => {
        await this.props.GetFilterList()
        console.log(this.props.filterList, 'filterList')

        let finalvendorlist = []
        let finalpos = []
        let finalwbsno = []
        let finalplantcode = []
        let finalemployees = []
        await finalemployees.push({ label: `Open`, value: 'opened' })
        await this.props.filterList[5].map(async (item) => {
            await finalemployees.push({ label: `${item.EmployeeName}`, value: item.EmployeeName })
        })
        await this.props.filterList[1].map(async (item) => {
            await finalplantcode.push({ label: item.PlantCode, value: item.PlantCode })
        })
        await this.props.filterList[2].map(async (item) => {
            await finalwbsno.push({ label: (item.WBSCode).substring(0, 6), value: (item.WBSCode).substring(0, 6) })
        })
        await this.props.filterList[3].map(async (item) => {
            await finalvendorlist.push({ label: item.VendorName, value: item.VendorName })
        })
        await this.props.filterList[4].map(async (item) => {
            await finalpos.push({ label: item.POSAPId, value: item.POSAPId })
        })
        let POSAPId = []
        let WBSCode = []
        let PlantCode = []
        let VendorName = []
        let employees = []
        await this.state.sortByPlantCode.map(async (item) => {
            await PlantCode.push({ label: item, value: item })
        })
        await this.state.sortByWBS.map(async (item) => {
            await WBSCode.push({ label: item, value: item })
        })
        await this.state.sortByPo.map(async (item) => {
            await POSAPId.push({ label: item, value: item })
        })
        await this.state.sortByVendor.map(async (item) => {
            await VendorName.push({ label: item, value: item })
        })
        await this.state.sortByEmployees.map(async (item) => {
            await employees.push({ label: item, value: item })
        })

        await this.setState({ finalvendorlist, finalpos, finalwbsno, finalplantcode, finalemployees, PlantCode, WBSCode, POSAPId, VendorName, employees })
    }

    handleSelectEmployees = async (e) => {
        let sortByEmployees = []
        let sortBy = 'all'
        let employees = []
        if (e.length > 0) {
            e.map((item) => {
                if (item.value !== 'opened') {
                    sortByEmployees.push(item.value)
                } else {
                    sortBy = 'opened'
                }
                employees.push(item)
                return item
            })
        }
        await this.setState({ sortByEmployees, employees, sortBy })
        await this.filterData()
    }

    handleSelectVendor = async (e) => {
        let sortByVendor = []
        let VendorName = []
        console.log(e, "HHHH")
        if (e.length > 0) {
            e.map((item) => {
                sortByVendor.push(item.value)
                VendorName.push(item)
                return item
            })
        }
        await this.setState({ sortByVendor, VendorName })
        this.getInspectorallocation(this.state.year, this.state.month)
    }

    handleSelectPO = async (e) => {
        let sortByPo = []
        let POSAPId = []
        if (e.length > 0) {
            e.map((item) => {
                sortByPo.push(item.value)
                POSAPId.push(item)
                return item
            })
        }
        await this.setState({ sortByPo, POSAPId })
        this.getInspectorallocation(this.state.year, this.state.month)
    }

    getInspectorallocation = async (year, month) => {
        await this.props.getInspectorAllocations(year, month)
        await this.setState({ calenderui: true })
        //this.props.getInspectorAllocationsByInspectorId(3,2021,1)
        this.getFilterList()
    }

    fun_month(i) {
        var month = [];

        month[1] = "January"; month[2] = "February"; month[3] = "March";
        month[4] = "April"; month[5] = "May"; month[6] = "June";
        month[7] = "July"; month[8] = "August"; month[9] = "September";
        month[10] = "October"; month[11] = "November"; month[12] = "December";

        return month[i]
    };

    changeMonth = async (direction) => {
        var year = this.state.year
        var month = this.state.month + direction
        if (month === 0) {
            month = 12
            year = year - 1
        } else if (month === 13) {
            month = 1
            year = year + 1
        }
        this.setState({ month, year })
        this.getInspectorallocation(year, month)
        this.setState({ allocatedDetail: null })
    }
    toggleFilter = async () => {
        this.setState({ isShowFilter: !this.state.isShowFilter })
    }
    clearFilter = async () => {
        await this.setState({
            isShowFilter: false,
            sortByPo: [],
            sortByVendor: [],
            sortByInspector: [],
            VendorName: [],
            InspectorName: []
        })
    }
    handleSelectVendor = async (e) => {
        let sortByVendor = []
        let VendorName = []
        console.log(e, "HHHH")
        if (e.length > 0) {
            e.map((item) => {
                sortByVendor.push(item.value)
                VendorName.push(item)
                return item
            })
        }
        await this.setState({ sortByVendor, VendorName })
    }
    handleSelectInspector = async (e) => {
        let sortByInspector = []
        let InspectorName = []
        if (e.length > 0) {
            e.map((item) => {
                sortByInspector.push(item.value)
                InspectorName.push(item)
                return item
            })
        }
        await this.setState({ sortByInspector, InspectorName })
    }
    getFilterList = async () => {
        await this.props.GetFilterList()
        console.log(this.props.filterList, 'filterList')

        let finalvendorlist = []
        let finalinspectorlist = []

        await this.props.filterList[3].map(async (item) => {
            await finalvendorlist.push({ label: item.VendorName, value: item.VendorName })
        })
        await this.props.filterList[11].map(async (item) => {
            await finalinspectorlist.push({ label: item.InspectorName, value: item.InspectorName })
        })
        let InspectorName = []
        let VendorName = []
        await this.state.sortByInspector.map(async (item) => {
            await InspectorName.push({ label: item, value: item })
        })
        await this.state.sortByVendor.map(async (item) => {
            await VendorName.push({ label: item, value: item })
        })
        await this.setState({ finalvendorlist, VendorName, finalinspectorlist, InspectorName })
    }


    render() {
        const customStyles = {
            option: (provided, state) => ({
                ...provided,
                borderBottom: '1px dotted pink',
                //   color: state.isSelected ? 'red' : 'blue',
                padding: "2px 10px",
            }),
            menu: (provided, state) => ({
                ...provided,
                width: "100%",
                minWidth: "max-content",
                zIndex: "999 !important",
            }),
        }
        console.log(this.props.allinspectorswithtypes, '===========')
        return (
            <div className="Container-fluid p-4">
                <div className="col-5 xs={last} pt-2" style={{ paddingLeft: 194, marginLeft: 766 }}>
                    <SearchBar toggleFilter={this.toggleFilter} clearFilter={this.clearFilter} filter={true} clear={true} btnName="" />
                </div>
                {this.state.isShowFilter ?
                    <div className="row justify-content-between pb-3 pt-3 m-0 border-radius-modal border-color filter-data pr-2 pl-2">
                        <div className="col">
                            <Select maxMenuHeight={500} placeholder="Vendor" isMulti value={this.state.VendorName} mode="multiple" hideSelectedOptions={false} closeMenuOnSelect={false} tabSelectsValue={false} controlShouldRenderValue={false} styles={customStyles} options={this.state.finalvendorlist} onChange={(e) => this.handleSelectVendor(e)} />
                        </div>
                        <div className="col">
                            <Select maxMenuHeight={500} placeholder="Inspector Name" isMulti value={this.state.InspectorName} mode="multiple" hideSelectedOptions={false} closeMenuOnSelect={false} tabSelectsValue={false} controlShouldRenderValue={false} styles={customStyles} options={this.state.finalinspectorlist} onChange={(e) => this.handleSelectInspector(e)} />
                        </div>
                    </div>
                    : null}
                {(this.state.calenderui === true && this.props.allinspectorswithtypes.loading === false) ?
                    <div className="pt-2">
                        <div className="row justify-content-between">
                            <div className="col-5 header">
                                <b>Resource Planner</b>
                            </div>

                            {/* <div className="col-md-6">
                                        <Link  to ={{ pathname: '/inspectiondashboard',state : {} }}> 
                                            <button className="btn2 btn-sms1 mr-4 float-right" type="submit"> Inspection Dashboard</button>
                                        </Link>
                                    </div>  */}

                            <div className="col-7 pt-3" style={{ paddingRight: 35 }}>
                                <SearchBar placeholder="Search" value={this.state.searchTerm} searchInputHandler={(e) => { this.handleISearch(e) }} searchClick={this.handleSearching} label="Search" toggleFilter={this.toggleFilter} clearFilter={this.clearFilter} filter={true} clear={true} btnName="" />
                            </div>
                        </div>
                        {this.state.isShowFilter ?
                            <div className="row justify-content-between pb-3 pt-3 m-0 border-radius-modal border-color filter-data pr-2 pl-2">
                                <div className="col">
                                    <Select maxMenuHeight={500} placeholder="Planner" isMulti value={this.state.employees} mode="multiple" hideSelectedOptions={false} closeMenuOnSelect={false} tabSelectsValue={false} controlShouldRenderValue={false} styles={customStyles} options={this.state.finalemployees} onChange={(e) => this.handleSelectEmployees(e)} />
                                </div>
                                {/* <div className="col">
                                    <Select maxMenuHeight={500} placeholder="Project Code" isMulti value={this.state.WBSCode} mode="multiple" hideSelectedOptions={false} closeMenuOnSelect={false} tabSelectsValue={false} controlShouldRenderValue={false} styles={customStyles} options={this.state.finalwbsno} onChange={(e) => this.handleSelectWBS(e)} />
                                </div> */}
                                <div className="col">
                                    <Select maxMenuHeight={500} placeholder="Vendor" isMulti value={this.state.VendorName} mode="multiple" hideSelectedOptions={false} closeMenuOnSelect={false} tabSelectsValue={false} controlShouldRenderValue={false} styles={customStyles} options={this.state.finalvendorlist} onChange={(e) => this.handleSelectVendor(e)} />
                                </div>
                                {/* <div className="col">
                                    <Select maxMenuHeight={500} placeholder="Plant" isMulti value={this.state.PlantCode} mode="multiple" hideSelectedOptions={false} closeMenuOnSelect={false} tabSelectsValue={false} controlShouldRenderValue={false} styles={customStyles} options={this.state.finalplantcode} onChange={(e) => this.handleSelectPlantCode(e)} />
                                </div> */}
                                <div className="col">
                                    <Select maxMenuHeight={500} placeholder="PO No." isMulti value={this.state.POSAPId} mode="multiple" hideSelectedOptions={false} closeMenuOnSelect={false} tabSelectsValue={false} controlShouldRenderValue={false} styles={customStyles} options={this.state.finalpos} onChange={(e) => this.handleSelectPO(e)} />
                                </div>
                                {/* <div className="col">
                                    <InputGroup>
                                        <FormControl className='outline-primary' type="text" readOnly placeholder="PO Dt." />
                                        <InputGroup.Append>
                                            <Button className="custom-drop-arrow" onClick={() => this.togglePoDocDate()} variant="outline-secondary"><FontAwesomeIcon icon={"chevron-down"} size="xs" /></Button>
                                        </InputGroup.Append>
                                    </InputGroup>
                                    {this.state.isShowPoDocDate ?
                                        <>
                                            <label>Start Date</label>
                                            <Form.Control className="width-90" type="date" onChange={(e) => { this.handlepoDocStartDate(e) }} placeholder="Start Date" value={this.state.poDocStartDate} />
                                            <label>End Date</label>
                                            <Form.Control className="width-90" type="date" onChange={(e) => { this.handlepoDocEndDate(e) }} id={`inspectionEndDate-datepicker`} name={`inspectionEndDate-datepicker`} placeholder="inspection End Date" value={this.state.poDocEndDate} />
                                        </>
                                        : null}
                                </div> */}
                            </div>
                            : null}
                        <div className="row pr-4">
                            <div className='col d-flex justify-content-between'>
                                <div>
                                    <FontAwesomeIcon icon={'long-arrow-alt-left'} className="submission-check-cirle mr-2" size="2x" onClick={() => this.changeMonth(-1)} />
                                </div>
                                <div>
                                    <b>{this.fun_month(this.state.month)} {this.state.year}</b>
                                </div>
                                <div>
                                    <FontAwesomeIcon icon={'long-arrow-alt-right'} className="submission-check-cirle ml-2" size="2x" onClick={() => this.changeMonth(1)} />
                                </div>
                            </div>
                        </div>
                        <div className="row pr-4">
                            <div className="col">
                                <Table className="p-4 table1 text-center resource-planner">
                                    <thead>
                                        <tr>
                                            <th>SUN</th>
                                            <th>MON</th>
                                            <th>TUE</th>
                                            <th>WED</th>
                                            <th>THU</th>
                                            <th>FRI</th>
                                            <th>SAT</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.props.allinspectorswithtypes.inspectorallocationAll.map((data, index) => (
                                            data.length > 0 ?
                                                <tr>
                                                    {(data[0].isAllocated === true) ? <td><div className="content">{data[0].day}
                                                        {data[0].inspectionDetail.map(item =>
                                                            <div className="allocated ellipsis" title={item.InspectorName + ' at ' + item.VendorName}>{item.InspectorName} at {item.VendorName}</div>
                                                        )}
                                                    </div></td> : data[0].day !== '' ? <td><div className="content">{data[0].day}</div></td> : <td><div className="content">{data[0].day}</div></td>}
                                                    {(data[1].isAllocated === true) ? (<td><div className="content"><span>{data[1].day}</span>
                                                        {data[1].inspectionDetail.map(item =>
                                                            <div className="allocated ellipsis" title={item.InspectorName + ' at ' + item.VendorName}>{item.InspectorName} at {item.VendorName}</div>
                                                        )}
                                                    </div></td>) : data[1].day !== '' ? <td ><div className="content">{data[1].day}</div></td> : <td><div className="content">{data[1].day}</div></td>}
                                                    {(data[2].isAllocated === true) ? <td><div className="content"><span>{data[2].day}</span>
                                                        {data[2].inspectionDetail.map(item =>
                                                            <div className="allocated ellipsis" title={item.InspectorName + ' at ' + item.VendorName}>{item.InspectorName} at {item.VendorName}</div>
                                                        )}
                                                    </div></td> : data[2].day !== '' ? <td ><div className="content">{data[2].day}</div></td> : <td><div className="content">{data[2].day}</div></td>}
                                                    {(data[3].isAllocated === true) ? <td><div className="content"><span>{data[3].day}</span>
                                                        {data[3].inspectionDetail.map(item =>
                                                            <div className="allocated ellipsis" title={item.InspectorName + ' at ' + item.VendorName}>{item.InspectorName} at {item.VendorName}</div>
                                                        )}
                                                    </div></td> : data[3].day !== '' ? <td ><div className="content">{data[3].day}</div></td> : <td><div className="content">{data[3].day}</div></td>}
                                                    {(data[4].isAllocated === true) ? <td><div className="content"><span>{data[4].day}</span>
                                                        {data[4].inspectionDetail.map(item =>
                                                            <div className="allocated ellipsis" title={item.InspectorName + ' at ' + item.VendorName}>{item.InspectorName} at {item.VendorName}</div>
                                                        )}
                                                    </div></td> : data[4].day !== '' ? <td ><div className="content">{data[4].day}</div></td> : <td><div className="content">{data[4].day}</div></td>}
                                                    {(data[5].isAllocated === true) ? (<td><div className="content"><span>{data[5].day}</span>
                                                        {data[5].inspectionDetail.map(item =>
                                                            <div className="allocated ellipsis" title={item.InspectorName + ' at ' + item.VendorName}>{item.InspectorName} at {item.VendorName}</div>
                                                        )}
                                                    </div></td>) : data[5].day !== '' ? <td><div className="content">{data[5].day}</div></td> : <td><div className="content">{data[5].day}</div></td>}
                                                    {(data[6].isAllocated === true) ? <td><div className="content"><span>{data[6].day}</span>
                                                        {data[6].inspectionDetail.map(item =>
                                                            <div className="allocated ellipsis" title={item.InspectorName + ' at ' + item.VendorName}>{item.InspectorName} at {item.VendorName}</div>
                                                        )}
                                                    </div></td> : data[6].day !== '' ? <td><div className="content">{data[6].day}</div></td> : <td><div className="content">{data[6].day}</div></td>}
                                                </tr>
                                                : null
                                        ))}
                                    </tbody>
                                </Table>
                            </div>
                            {this.state.allocatedDetail ?
                                this.state.allocatedDetail.map((item, index) => (
                                    <div className="col-5" style={{ display: this.state.allocatedinspectionIndex === index ? 'block' : 'none' }}>
                                        <h4 style={{ color: 'black', textAlign: ' center', verticalAlign: 'middle' }}>Allocated Detail</h4>
                                        <div className="row">
                                            {index === 0 ? '' :
                                                <FontAwesomeIcon icon={'long-arrow-alt-left'} className="submission-check-cirle ml-2 float-left" size="2x" onClick={() => this.changeAllocatedInspection(index - 1)} />
                                            }
                                            {index === (this.state.allocatedDetail.length - 1) ? '' :
                                                <FontAwesomeIcon icon={'long-arrow-alt-right'} className="float-right  submission-check-cirle  mr-2" size="2x" onClick={() => this.changeAllocatedInspection(index + 1)} />
                                            }
                                        </div>
                                        <div className="row">
                                            <div className="col">
                                                <div className="row">
                                                    <div className="col"><b>Total Allocation : </b></div>
                                                    <div className="col">{item.POSAPId}</div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="row">
                                            <div className="col">
                                                <div className="row">
                                                    <div className="col"><b>PO No : </b></div>
                                                    <div className="col">{item.POSAPId}</div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="row">
                                            <div className="col">
                                                <div className="row">
                                                    <div className="col"><b>Item No : </b></div>
                                                    <div className="col">{item.POLineItemSAPCode}</div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="row">
                                            <div className="col">
                                                <div className="row">
                                                    <div className="col"><b>PO Date : </b></div>
                                                    <div className="col">{dateFormater(item.POCreationDate)}</div>
                                                </div>
                                            </div>
                                        </div>

                                        {/* <div className="row">
                                        <div className="col">
                                            <div className="row">
                                                <div className="col"><b>Item Delivery Date : </b></div>
                                                <div className="col">{dateFormater(item.PODeliveryDate)}</div>
                                            </div>
                                        </div>
                                    </div> */}

                                        <div className="row">
                                            <div className="col">
                                                <div className="row">
                                                    <div className="col"><b>Supplier Name : </b></div>
                                                    <div className="col">{item.VendorName}</div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="row">
                                            <div className="col">
                                                <div className="row">
                                                    <div className="col"><b>Inspection Call No : </b></div>
                                                    <div className="col">{item.InspectionCallNo}</div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="row">
                                            <div className="col">
                                                <div className="row">
                                                    <div className="col"><b>Location : </b></div>
                                                    <div className="col">{item.Location}</div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="row">
                                            <div className="col">
                                                <div className="row">
                                                    <div className="col"><b>Proposed Inspection Date : </b></div>
                                                    <div className="col">{dateFormater(item.VendorProposedDate)}</div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="row">
                                            <div className="col">
                                                <div className="row">
                                                    <div className="col"><b>Stage to inspect : </b></div>
                                                    <div className="col">{item.StageName}</div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="row">
                                            <div className="col">
                                                <div className="row">
                                                    <div className="col"><b>Item Description : </b></div>
                                                    <div className="col"> {item.POLineItemDescription} </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="row">
                                            <div className="col">
                                                <div className="row">
                                                    <div className="col "><b>Inspector Name : </b></div>
                                                    <div className="col"> {item.InspectorName}</div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="row">
                                            <div className="col">
                                                <div className="row">
                                                    <div className="col "><b>Allocated Inspection Date : </b></div>
                                                    <div className="col">{dateFormater(item.InspectionStartDate) + ' - ' + dateFormater(item.InspectionEndDate)}</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))
                                : ''}
                        </div>
                    </div>
                    : null}
            </div>
        )
    }
}


const mapStateToProps = (state) => ({ allinspectorswithtypes: state.inspectionReducer, filterList: state.masterReducer.filterList })
export default connect(mapStateToProps, { getAllInspectorswithTypes, getInspectorAllocationsByInspectorId, getInspectorAllocations, GetInspectorAllocationsByInspectorIdWithRange, getInspectionDetailsByInspectorID, postAssignInspector, getInspectionDetailsByCallID, GetFilterList })(ResourcePlanner)
